import {Component, Input, Output, EventEmitter} from '@angular/core';
import {Page} from "./page";
import * as _ from "lodash";

@Component({
    selector: 'eva-pager',
    templateUrl: './eva-pager.component.html',
})
export class EvaPagerComponent {

    @Input() config:Page;
    @Output() pageChanged = new EventEmitter();
    constructor() { }

    //Implementacion front side pager. Cuando amerite extenderlo a server side sobreescribiendo este metodo
    changePage(){
        let startItem = this.config.itemsPerPage*this.config.currentPage;
        this.config.pageItems = this.config.items.slice(startItem-this.config.itemsPerPage, startItem);
        this.pageChanged.emit({page: this.config});
    }

    previous(){
        this.config.currentPage=this.config.currentPage-1;
        this.changePage();
    }

    next(){
        this.config.currentPage=this.config.currentPage+1;
        this.changePage();
    }

    goTo(pageNumber:number){
        this.config.currentPage=pageNumber;
        this.changePage();
    }

    getActualPages(){
        if(!!this.config && (this.config.numPages > 0)){
            if(this.config.numPages < 6 || (this.config.currentPage <= 3)){
                return _.range(1, (this.config.numPages<5)?(this.config.numPages+1):6);
            }else if(this.config.currentPage > 3 && this.config.currentPage >= this.config.numPages-1){
                return _.range(this.config.numPages-4, this.config.numPages+1);
            } else {
                return _.range(this.config.currentPage-2, this.config.currentPage+3);
            }
        } else {
            return [];
        }
    }
}


// WEBPACK FOOTER //
// ./public/upgrade/shared/pager/eva-pager.component.ts